/**
 * DeSight Shopify X | v1.0.0
 * Main JavaScript Entry Point
 *
 * This file compiles to /assets/desight-main.js
 * It extends the existing Shopify theme without overwriting it.
 */

(function () {
  'use strict';

  // =============================================================================
  // UTILITIES
  // =============================================================================

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Throttle function
  function throttle(func, limit) {
    let inThrottle;
    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }

  // Device detection
  function isMobile() {
    return window.innerWidth < 750;
  }

  function isTablet() {
    return window.innerWidth >= 750 && window.innerWidth < 990;
  }

  function isDesktop() {
    return window.innerWidth >= 990;
  }

  // =============================================================================
  // MODULES
  // =============================================================================

  // Background Video Module
  function initBackgroundVideo() {
    if (!customElements.get('video-background-component')) {
      customElements.define('video-background-component', class extends HTMLElement {
        connectedCallback() {
          this.videoElement = this.querySelector('video');
          this.videoSources = this.querySelectorAll('source[data-video-source]');

          if (this.videoElement && this.videoSources.length > 0) {
            this.loadVideoSources();
          }
        }

        loadVideoSources() {
          this.videoSources.forEach(source => {
            const videoUrl = source.getAttribute('data-video-source');
            if (videoUrl) {
              source.setAttribute('src', videoUrl);
            }
          });

          this.videoElement.load();
        }
      });
    }
  }


  // =============================================================================
  // COMPONENTS
  // =============================================================================
  // Add custom components here

  // =============================================================================
  // INITIALIZATION
  // =============================================================================

  // Framework loaded indicator

  document.addEventListener('DOMContentLoaded', function () {
    // Check if CSS is loaded
    var cssLoaded = getComputedStyle(document.documentElement).getPropertyValue('--desight-framework-loaded');

    // Initialize modules
    initBackgroundVideo();

    // Device detection
    var deviceType = isMobile() ? 'Mobile' : isTablet() ? 'Tablet' : 'Desktop';

    // Initialize components
    // CustomComponent.init();
  });

  // Export utilities for global use
  window.DeSight = {
    version: '1.0.0',
    utils: {
      debounce: debounce,
      throttle: throttle,
      isMobile: isMobile,
      isTablet: isTablet,
      isDesktop: isDesktop
    }
  };

})();

// =============================================================================
// COMPONENTS
// =============================================================================
// Loading Screen Component
//= include components/loading-screen.js

// Marketing Pop-Up Component
//= include components/marketing-popup.js

// Events Component
//= include components/events.js

// =============================================================================
// MODULES
// =============================================================================
// Cross-Selling Module
//= include modules/cross-selling.js

// Free Gift Module
//= include modules/free-gift.js
